"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ATMockImportEngine () {
        return ATMockImportEngine;
    },
    get MockAirtable () {
        return MockAirtable;
    }
});
const _nodestream = require("node:stream");
const _mockResponses = require("./mockResponses");
const _mockResponseData = require("./mockResponseData");
let ATMockImportEngine = class ATMockImportEngine {
    async initialize(_param) {
        return {
            data: _mockResponses.initializeHtml,
            status: 200,
            statusText: 'OK',
            headers: _mockResponses.initializeHeader,
            config: {}
        };
    }
    async read(_info) {
        const stream = _nodestream.Readable.from([
            JSON.stringify(_mockResponses.readResponse)
        ]);
        return {
            data: stream,
            status: 200,
            statusText: 'OK',
            headers: {},
            config: {}
        };
    }
    async readView(viewId, _info) {
        const stream = _nodestream.Readable.from([
            JSON.stringify(_mockResponses.viewsResponse[viewId])
        ]);
        return {
            data: stream,
            status: 200,
            statusText: 'OK',
            headers: {},
            config: {}
        };
    }
    atBase(_param) {
        return (title)=>new MockAirtable(title);
    }
};
let MockAirtable = class MockAirtable {
    select(_selectParams) {
        return this;
    }
    eachPage(pageHandle, done) {
        void (async ()=>{
            let cursor = 0;
            let currentRecord = _mockResponseData.mockResponseData[this.title][cursor++];
            while(currentRecord){
                await pageHandle(currentRecord.records, ()=>{
                    currentRecord = _mockResponseData.mockResponseData[this.title][cursor++];
                });
            }
            done(undefined);
        })();
    }
    constructor(title){
        this.title = title;
    }
};
